import React, { useState } from "react";
import ReactDOM from "react-dom";
import zhCN from "antd/es/locale/zh_CN";
import enUS from "antd/es/locale/en_US";
import "dayjs/locale/zh-cn";
import { ConfigProvider } from "antd";
import inject from "inject";
import "./index.less";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider, observer } from "mobx-react";
import stores from "./store";
import "./lang/i18n";

const Page = observer(() => {
  const globalStore = inject("Base");
  return (
    <ConfigProvider locale={globalStore.i18nLang === "zh" ? zhCN : enUS}>
      <App />
    </ConfigProvider>
  );
});
ReactDOM.render(
  <Provider {...stores}>
    <Page />
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
